/**
 * Grouped supported preview extension types.
 * Used to determine previewable files and display supported types in the UI.
 */
export const SUPPORTED_PREVIEW_EXTENSION_GROUPS = [
  { label: "Documents", extensions: ["pdf", "txt", "json"] },
  { label: "Images", extensions: ["jpg", "jpeg", "png", "gif", "bmp", "webp"] },
  { label: "Videos", extensions: ["mp4", "webm", "ogg"] },
  { label: "Audio", extensions: ["mp3", "wav", "aac", "flac"] },
] as const;

/**
 * Checks if a file type is previewable. Supported extensions are defined in
 * `SUPPORTED_PREVIEW_EXTENSION_GROUPS`. The render-switch in `FilePreview.tsx`
 * must stay in sync with the groups in this file.
 */
export const isFileTypePreviewable = (fileExtension: string): boolean => {
  const extension = fileExtension.split(".").pop()?.toLowerCase();
  const previewableExtensions: string[] =
    SUPPORTED_PREVIEW_EXTENSION_GROUPS.flatMap((group) => [
      ...group.extensions,
    ]);
  return !!extension && previewableExtensions.includes(extension);
};
